import { Flex, Icon, List, Text, useColorModeValue } from "@chakra-ui/react";
import CurrencyIcon from "@icons/CurrencyIcon";
import CheckoutSuccessButtons from "../CheckoutSuccessButtons/CheckoutSuccessButtons";
import CheckoutSuccessContainer from "../CheckoutSuccessContainer/CheckoutSuccessContainer";
import {
  ContactUsCard,
  ShareEventCard,
} from "../CheckoutSuccessCTA/CheckoutSuccessCTACards";
import CheckoutSuccessEventInfoCard from "../CheckoutSuccessEventInfo/CheckoutSuccessEventInfoCard/CheckoutSuccessEventInfoCard";
import { EventHost } from "../CheckoutSuccessEventInfo/CheckoutSuccessEventInfoItems/CheckoutSuccessEventInfoItems";
import CheckoutSuccessHeadings from "../CheckoutSuccessHeadings/CheckoutSuccessHeadings";
import { CheckoutSuccessContentProps } from "../types";

const HOST = process.env.NEXT_PUBLIC_HOST || "https://app.moongate.id";

const CheckoutSuccessMembership = ({
  event,
  tier,
  info,
  itemsCount,
  itemsCurrency,
  itemsFinalAmount,
  language,
}: CheckoutSuccessContentProps) => (
  <>
    <CheckoutSuccessContainer>
      <CheckoutSuccessHeadings />
      <CheckoutSuccessEventInfoCard
        imgSrc={tier?.imageUrl || info.hero || info.banner}
        cardTitle={info.name}
        itemsCount={itemsCount}
      >
        <List
          marginTop={4}
          spacing={4}
          style={{ maxWidth: "20rem", wordWrap: "break-word" }}
        >
          <Flex
            direction="row"
            justifyContent="left"
            alignItems="center"
            gap="0.95rem"
            marginLeft={1}
            width="100%"
          >
            <Icon
              as={CurrencyIcon}
              className="svg-primary flex-shrink-0"
              boxSize={5}
              fill={"transparent"}
              alt="currency icon"
            />

            <Text
              whiteSpace="pre"
              fontSize="md"
              fontWeight="medium"
              color={useColorModeValue("", "neutral.10")}
            >
              <>
                {itemsCurrency} $ {itemsFinalAmount}
              </>
            </Text>
          </Flex>
          {info.organizer && info.organizer.name && (
            <EventHost eventType={event.type} info={info} language={language} />
          )}
        </List>
      </CheckoutSuccessEventInfoCard>

      <CheckoutSuccessButtons
        redirectToAppText="See my NFT"
        redirectToEventText="Back to Homepage"
      />

      <Flex
        width="max-content"
        direction={{ base: "column", lg: "row" }}
        justifyContent="center"
        alignItems="stretch"
        marginTop={8}
        gap={6}
      >
        <ShareEventCard
          eventType={event.type}
          language={language}
          url={event.toURL(HOST)}
        />
        <ContactUsCard language={language} />
      </Flex>
    </CheckoutSuccessContainer>
  </>
);

export default CheckoutSuccessMembership;
